import type { Alert, AlertPageStore } from '@ctct/state-client-layer';

import type { Init } from '../types';

export class AlertService {
  constructor(private pageStore: AlertPageStore) {}

  public api() {
    return {
      addAlert: this.addAlert,
      removeAlert: (id: string) => {
        this.pageStore.setState(({ alerts }) => ({ alerts: alerts.filter((alert) => alert.id !== id) }));
      },
      removeAllAlerts: () => {
        this.pageStore.setState({ alerts: [] });
      },
    };
  }

  public data() {
    return {};
  }

  public handlers() {
    return {};
  }

  public onMount = (locationState?: Init['locationState']) => {
    if (locationState?.successMessage) {
      this.addAlert({
        id: 'location-state-success-message',
        variant: 'success',
        message: locationState.successMessage,
      });
    }

    if (locationState?.errorMessage) {
      this.addAlert({
        id: 'location-state-error-message',
        variant: 'warning',
        message: locationState.errorMessage,
      });
    }
  };

  private addAlert = (alert: Alert) => {
    const { alerts } = this.pageStore.getState();
    const alreadyExist = alerts.find((a) => a.id === alert.id);

    if (!alreadyExist) {
      this.pageStore.setState({ alerts: [...alerts, alert] });
    }
  };
}
